import {createContext} from "react";

import {ThirdPartyService} from "@/lib/queries/checks.ts";

export const ThirdPartySubComponentSelectContext = createContext<ThirdPartyService | null>(null);
